import React, {useContext, useEffect} from 'react';
import './drawer.scss';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ClassIcon from '@material-ui/icons/Class';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import CreateIcon from '@material-ui/icons/Create';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import AssessmentIcon from '@material-ui/icons/Assessment';
import QuizIcon from '@mui/icons-material/Quiz';
import NoteIcon from '@mui/icons-material/Note';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {StoreContext} from "../../store/context";
import {withRouter} from "react-router-dom";

import {ROLE_ADMIN} from "../../utils/constants";
import {useViewport} from "../viewport";

const drawerWidth = 300;
const TemporaryDrawer = (props) => {
    const useStyles = makeStyles((theme) => ({
        nested: {
            paddingLeft: theme.spacing(4),
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
        },
        drawerPaper: {
            width: drawerWidth,
        },
    }));

    const { width } = useViewport();

    const classes = useStyles();
    const { state, actions } = useContext(StoreContext);
    const { showNavDrawer } = state.generalStates;
    const role = sessionStorage.getItem("role");
    const { toggleNavigationDrawer } = actions.generalActions;
    const [openCollapseManagement, setOpenCollapseManagement] = React.useState(true);
    const [openCollapseRegistration, setOpenCollapseRegistration] = React.useState(true);
    const [openCollapsePayment, setOpenCollapsePayment] = React.useState(true);
    const [openCollapseFinance, setOpenCollapseFinance] = React.useState(true);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        toggleNavigationDrawer(open);
    };

    function handleOpenRegistration(){
        setOpenCollapseRegistration(!openCollapseRegistration);
    }

    function handleOpenManagement(){
        setOpenCollapseManagement(!openCollapseManagement);
    }

    function handleOpenPayment(){
        setOpenCollapsePayment(!openCollapsePayment);
    }

    function handleOpenFinance(){
        setOpenCollapseFinance(!openCollapseFinance);
    }

    const list = (anchor) => (
        <div
            className="navigation-list"
            role="presentation"
            onClick={() => toggleNavigationDrawer(width > 1000)}>
            <List>
                <ListItem button onClick={handleOpenRegistration}>
                    <ListItemIcon><CreateIcon /></ListItemIcon>
                    <ListItemText primary="Registration" />
                    {openCollapseRegistration ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openCollapseRegistration} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/student/register")}}>
                            <ListItemIcon>
                                <ClassIcon />
                            </ListItemIcon>
                            <ListItemText primary="Student Registration" />
                        </ListItem>
                        {role === ROLE_ADMIN && <ListItem button className={classes.nested} onClick={() => {props.history.push("/teacher/register")}}>
                            <ListItemIcon>
                                <PermIdentityIcon />
                            </ListItemIcon>
                            <ListItemText primary="Teacher Registration" />
                        </ListItem>}
                        {/*<ListItem button className={classes.nested} onClick={() => {props.history.push("/course/register")}}>*/}
                        {/*    <ListItemIcon>*/}
                        {/*        <PermIdentityIcon />*/}
                        {/*    </ListItemIcon>*/}
                        {/*    <ListItemText primary="Course Registration" />*/}
                        {/*</ListItem>*/}
                    </List>
                </Collapse>
                <ListItem button onClick={handleOpenManagement}>
                    <ListItemIcon>
                        <MenuBookIcon />
                    </ListItemIcon>
                    <ListItemText primary="Management" />
                    {openCollapseManagement ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openCollapseManagement} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/classroom")}}>
                            <ListItemIcon>
                                <ClassIcon />
                            </ListItemIcon>
                            <ListItemText primary="Classroom" />
                        </ListItem>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/student/management")}}>
                            <ListItemIcon>
                                <PermIdentityIcon />
                            </ListItemIcon>
                            <ListItemText primary="Student Directory" />
                        </ListItem>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/student/enrolment/management")}}>
                            <ListItemIcon>
                                <PermIdentityIcon />
                            </ListItemIcon>
                            <ListItemText primary="New Enrolments" />
                        </ListItem>
                        {role === ROLE_ADMIN && <ListItem button className={classes.nested} onClick={() => {props.history.push("/teacher/management")}}>
                            <ListItemIcon>
                                <PermIdentityIcon />
                            </ListItemIcon>
                            <ListItemText primary="Teacher Directory" />
                        </ListItem>}
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/announcements")}}>
                            <ListItemIcon>
                                <ClassIcon />
                            </ListItemIcon>
                            <ListItemText primary="Announcement" />
                        </ListItem>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/student/quiz")}}>
                            <ListItemIcon>
                                <QuizIcon />
                            </ListItemIcon>
                            <ListItemText primary="Quiz" />
                        </ListItem>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/student/notes")}}>
                            <ListItemIcon>
                                <NoteIcon />
                            </ListItemIcon>
                            <ListItemText primary="Notes" />
                        </ListItem>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/student/timetable")}}>
                            <ListItemIcon>
                                <AccessAlarmIcon />
                            </ListItemIcon>
                            <ListItemText primary="Timetable" />
                        </ListItem>
                    </List>
                </Collapse>
                <ListItem button onClick={handleOpenPayment}>
                    <ListItemIcon>
                        <AttachMoneyIcon />
                    </ListItemIcon>
                    <ListItemText primary="Payment" />
                    {openCollapsePayment ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openCollapsePayment} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/payment/history")}}>
                            <ListItemIcon>
                                <AssessmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="History"/>
                        </ListItem>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/student/tuition/payment")}}>
                            <ListItemIcon>
                                <AssessmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Student - Tuition Fees"/>
                        </ListItem>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/student/misc/payment")}}>
                            <ListItemIcon>
                                <AssessmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Student - Misc Fees" />
                        </ListItem>
                        <ListItem button className={classes.nested} onClick={() => {props.history.push("/student/tuition/receipt")}}>
                            <ListItemIcon>
                                <AssessmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Student - Receipt"/>
                        </ListItem>
                        {role === ROLE_ADMIN && <ListItem button className={classes.nested}>
                            <ListItemIcon>
                                <AssessmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Teachers Salary" onClick={() => {props.history.push("/teachers/salary")}}/>
                        </ListItem>}
                    </List>
                </Collapse>
                {role === ROLE_ADMIN && <ListItem button onClick={handleOpenFinance}>
                    <ListItemIcon>
                        <AttachMoneyIcon />
                    </ListItemIcon>
                    <ListItemText primary="Finance" />
                    {openCollapseFinance ? <ExpandLess /> : <ExpandMore />}
                </ListItem>}
                {role === ROLE_ADMIN && <Collapse in={openCollapseFinance} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested}>
                            <ListItemIcon>
                                <AssessmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Students Financial report" onClick={() => {props.history.push("/finance/report/student")}}/>
                        </ListItem>
                        <ListItem button className={classes.nested}>
                            <ListItemIcon>
                                <AssessmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Monthly Financial report" onClick={() => {props.history.push("/finance/report/month")}}/>
                        </ListItem>
                    </List>
                </Collapse> }
            </List>
        </div>
    );

    return (
        <SwipeableDrawer
            className={classes.drawer}
            anchor={"left"}
            variant={width< 1000 ? "temporary": "persistent"}
            open = {showNavDrawer}
            classes={{
                paper: classes.drawerPaper,
            }}
            onOpen={toggleDrawer( true)}
            onClose={toggleDrawer(false)}
        >
            {list("left")}
        </SwipeableDrawer>
    );
}

export default withRouter(TemporaryDrawer)
